import styled from "styled-components";

export const ListItemContainer = styled.div`
    min-height: 50px;
    cursor: pointer;
    border-radius: 12px;
    padding: 8px 12px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;
    transition: background-color 0.2s ease;
    box-sizing: border-box;

    &:hover {
        background-color: #353c5d;
    }

    &.active {
        background-color: #353c5d;
    }

    &.application-late {
        border: 1px solid #712f2f;
        background: #b900003d !important;

        &.active {
            background-color: #a63636b3 !important;
        }

        &:hover {
            background-color: #a63636b3 !important;
        }
    }

    @media (max-width: 1400px) {
        padding: 6px 10px;
        margin-top: 6px;
        margin-bottom: 6px;
    }

    @media (max-width: 768px) {
        padding: 5px 8px;
        margin-top: 4px;
        margin-bottom: 4px;
        border-radius: 10px;
        min-height: 45px;
    }
`;

export const ListItemDivider = styled.div`
    border: 1px solid #3a3b47;
    margin: 8px 0;
    transform: scaleY(0.5);

    @media (max-width: 768px) {
        margin: 6px 0;
    }
`;
